import React, { useEffect, useState } from 'react'
import OrderStatus from './OrderStatus'
import CarouselDashboard from './Carousel'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';
import { GetSPDashboard } from '../../API/GetData'
import InvoiceStatus from './InvoiceStatus'
dayjs.extend(utc);

const Dashboard = () => {

  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await GetSPDashboard();
        setData(res);
      } catch (error) {
        console.log(error);
      }
    }

    fetchData();

  }, []);


  return (
    <div className="flex flex-col gap-4">
      {/* NEWS */}
      <CarouselDashboard />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {/* ORDER STATUS */}
        <OrderStatus
          dataSource={data.Order}
        />
        {/* INVOICE STATUS */}
        <InvoiceStatus
          dataSource={data.Invoice}
        />
      </div>
    </div>
  )
}

export default Dashboard